'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleResponse = exports.debug = exports.body = exports.query = exports.params = exports.uri = exports.url = exports.headers = exports.method = exports.rekuest = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash.flow');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.isfunction');

var _lodash4 = _interopRequireDefault(_lodash3);

var _http = require('./http');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
  method: 'get',
  headers: {},
  url: '',
  uri: '',
  params: {},
  query: {},
  body: null,
  debug: false,
  handleResponse: function handleResponse(x) {
    return x;
  }
};

var rekuest = function rekuest(req) {
  for (var _len = arguments.length, alts = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    alts[_key - 1] = arguments[_key];
  }

  if ((0, _lodash4.default)(req)) {
    alts.unshift(req);
    req = _extends({}, defaults);
  }

  if (!req) {
    return rekuest(defaults);
  }

  if (alts.length) {
    var alteration = (0, _lodash2.default)(alts);
    return rekuest(alteration(req));
  }

  return function () {
    for (var _len2 = arguments.length, nextAlts = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      nextAlts[_key2] = arguments[_key2];
    }

    if (nextAlts.length) {
      var _alteration = (0, _lodash2.default)(nextAlts);
      return rekuest(_alteration(req));
    }

    return (0, _http.send)(req);
  };
};

exports.default = rekuest;
exports.rekuest = rekuest;
var method = exports.method = function method(m) {
  return function (req) {
    return _extends({}, req, { method: m });
  };
};

var headers = exports.headers = function headers(h) {
  return function (req) {
    return _extends({}, req, { headers: _extends({}, req.headers, h) });
  };
};

var url = exports.url = function url(u) {
  return function (req) {
    return _extends({}, req, { url: u });
  };
};

var uri = exports.uri = function uri(u) {
  return function (req) {
    return _extends({}, req, { uri: '' + req.uri + u });
  };
};

var params = exports.params = function params(p) {
  return function (req) {
    return _extends({}, req, { params: _extends({}, req.params, p) });
  };
};

var query = exports.query = function query(q) {
  return function (req) {
    return _extends({}, req, { query: _extends({}, req.query, q) });
  };
};

var body = exports.body = function body(b) {
  return function (req) {
    return _extends({}, req, { body: _extends({}, req.body || {}, b) });
  };
};

var debug = exports.debug = function debug(d) {
  return function (req) {
    return _extends({}, req, { debug: d });
  };
};

var handleResponse = exports.handleResponse = function handleResponse(h) {
  return function (req) {
    return _extends({}, req, { handleResponse: h });
  };
};